import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import JudgeForm from './judges/JudgeForm';
import JudgeList from './judges/JudgeList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addJudgesAction } from '../../actions/judgesActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { JUECES_CREAR, PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const Judges = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addJudgesAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, JUECES_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Jueces' 
                subtitle='Personas' 
                nodes={nodes}
                actions={actions}
                component={JudgeList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <JudgeForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Judges;